import { useCallback } from "react";
import { useSelector } from "react-redux";

import { useSwitchActiveCompany } from "../shared/hooks/useSwitchActiveCompany";
import { getNotificationCompanyId } from "./notificationHelpers";

export const getNotificationCompanyName = (notification, companies = []) => {
  const notificationCompanyId = getNotificationCompanyId(notification);
  if (!notificationCompanyId) return "";

  const membership = companies.find((item) => String(item?.companyId ?? item?.company?.id ?? item?.id) === String(notificationCompanyId));
  return membership?.company?.businessName || membership?.company?.name || membership?.businessName || membership?.name || "";
};

export const useEnsureNotificationCompany = () => {
  const activeCompanyId = useSelector((state) => state.userState.activeCompanyId ?? state.userState.company?.id);
  const { switchActiveCompany, isSwitchingCompany } = useSwitchActiveCompany();

  const ensureNotificationCompany = useCallback(
    async (notification) => {
      const notificationCompanyId = getNotificationCompanyId(notification);
      if (!notificationCompanyId || String(notificationCompanyId) === String(activeCompanyId)) return false;

      await switchActiveCompany(notificationCompanyId);

      return true;
    },
    [activeCompanyId, switchActiveCompany],
  );

  return {
    ensureNotificationCompany,
    shouldSwitchNotificationCompany: (notification) => {
      const notificationCompanyId = getNotificationCompanyId(notification);
      return Boolean(notificationCompanyId && String(notificationCompanyId) !== String(activeCompanyId));
    },
    isSwitchingNotificationCompany: isSwitchingCompany,
  };
};
